import {FormArray, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {InputSelectOptionGroupComponent, NumberPipe, TrueFalseComponent} from '@brunata-angular/ui';
import {NgbModule, NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {InputTypeaheadComponent} from '@brunata-angular/ui';
import {InputNumberGroupComponent} from '@brunata-angular/ui';
import {v4 as uuidv4} from 'uuid';
import {CostSpecificationControl} from '../reporting-form-controls';

@Component({
    selector: 'app-costs-table',
    templateUrl: './costs-table.component.html',
    styleUrls: ['./costs-table.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslatePipe,
        TrueFalseComponent,
        ReactiveFormsModule,
        NumberPipe,
        FormsModule,
        NgbModule,
        InputNumberGroupComponent,
        InputTypeaheadComponent,
        InputSelectOptionGroupComponent,
        NgbPopover,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostsTableComponent implements OnInit {
    id: string = uuidv4();
    @Input({required: true}) openForEdit!: boolean;
    @Input({required: true}) costSpecificationFormArray = new FormArray<CostSpecificationControl>(
        [],
    );
    @Input() costUnitMap = new Map<string, string>([]);
    @Input() vatMap = new Map<string | null, string>([]);
    @Input() lineTextMap = new Map<string, string>([]);
    @Input() creatingMode = false;

    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    deleteCostLine(costSpecificationControl: CostSpecificationControl): void {
        if (costSpecificationControl.value.webBillCostSpecification === null) {
            const indexToRemove =
                this.costSpecificationFormArray.controls.indexOf(costSpecificationControl);
            this.costSpecificationFormArray.removeAt(indexToRemove);
        } else {
            costSpecificationControl.controls.deleted.setValue(true);
        }
    }

    restoreCostLine(costSpecificationControl: CostSpecificationControl): void {
        costSpecificationControl.controls.deleted.setValue(false);
    }

    ngOnInit(): void {
        this.costSpecificationFormArray.valueChanges.subscribe(() => {
            this.changeDetectorRef.detectChanges();
        });

        this.costSpecificationFormArray.controls = this.costSpecificationFormArray.controls.sort(
            (a, b) =>
                Number(a.value.webBillCostSpecification?.lineNo) -
                Number(b.value.webBillCostSpecification?.lineNo),
        );
    }
}
